import { cropToCanvas } from 'react-image-crop';
function getCroppedFileName(originalName) {
    const lastDotIndex = originalName.lastIndexOf('.');
    if (lastDotIndex <= 0) {
        return `${originalName || 'image'}_cropped.jpg`;
    }
    return `${originalName.slice(0, lastDotIndex)}_cropped.jpg`;
}
export default async function getCroppedImageFile(image, crop, originalFile) {
    if (!crop.width || !crop.height) {
        throw new Error('Invalid crop dimensions');
    }
    const canvas = document.createElement('canvas');
    await cropToCanvas(image, canvas, crop);
    // Editor crops are photos/screenshots — emit JPEG; uploadFile.web.ts runs
    // compressorjs for final resize/quality (max 1600px, q≈0.82).
    const blob = await new Promise(resolve => {
        canvas.toBlob(resolve, 'image/jpeg', 0.85);
    });
    if (!blob) {
        throw new Error('Failed to create cropped image');
    }
    return new File([blob], getCroppedFileName(originalFile.name), {
        type: 'image/jpeg',
        lastModified: Date.now(),
    });
}
